import actionTypes from './actionTypes';
import type { IRateEngineShort } from './types';

const actions = {
  fetchRequest: () => ({ type: actionTypes.FETCH_REQUEST }),
  fetchSuccess: (data: IRateEngineShort[]) => ({ type: actionTypes.FETCH_SUCCESS, payload: { data } }),
  fetchError: () => ({ type: actionTypes.FETCH_ERROR }),
};

export default actions;
